define('SuiteDynamics.HomePageHeroVideo.HeroVideo.View',
	[
		'herovideo.tpl',
		'Backbone'
	],
	function (
		herovideo_tpl,
		Backbone
	)
{
	'use strict';

	return Backbone.View.extend({
		template: herovideo_tpl,

		initialize: function(options) {
			var environment = options.container.getComponent('Environment');
			this.isEnabled = environment.getConfig('homePageHeroVideo.enabled');
			this.videoUrl = environment.getConfig('homePageHeroVideo.videoUrl');
		},

		getContext: function() {
			return {
				isEnabled: this.isEnabled,
				videoUrl: this.videoUrl
			}
		}
	});
});
